module.exports = __webpack_public_path__ + "img/winona_deepsleep_modal.7e676862.jpg";